<app-sale-order-grid
    [permissionKey]="'saleOrders.list'"
    [filter]="['ThirdId.Id eq ' + element.Id]"
    (add)="onAddButtonClicked()"
    [canDelete]="true"
    [showPager]="false"
    [columns]="SaleOrderColumns"
></app-sale-order-grid>